var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(" "+_vm._s(_vm.$t("time.buffer.title"))+" ")]),_c('inputSelect',{key:_vm.getDefaultDuration(),attrs:{"settings":{
      value: _vm.getDefaultDuration(),
      default: _vm.getDefaultDuration(),
      values: _vm.getValues()
    },"callback":_vm.setSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }